module.exports = __webpack_public_path__ + "static/media/logo-white.a5833549.svg";